import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import AddIcon from '@material-ui/icons/Add';

const styles = () => ({
  root: {},
});

const AddButton = ({
  className,
  classes,
  onClick,
  test,
}) => {
  return (
    <IconButton
      className={classNames(classes.root, className)}
      color={'primary'}
      title={'Add'}
      icon={AddIcon}
      onClick={onClick}
      test={test}
    />
  );
};

AddButton.defaultProps = {
  className: '',
  test: 'add-button',
};

AddButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(AddButton);
